const validator = {
  require: function(value) {
    return !value.length;
  },
  idCard: function(value) {
    // 身份证正则表达式(15位)
    let idCard1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
    // 身份证正则表达式(18位)
    let idCard2 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}[x\d]$/i;
    // 香港：A123456(7)、A123456(X)、A1234567、A123456X
    let HongKong = /^[A-Za-z]{1}[0-9]{6}(([0-9|A-Za-z])|(\([0-9|A-Za-z]\)))$/;
    // 台湾：A234567893
    let Taiwan = /^[a-zA-Z]{1}[0-9]{9}$/;
    // 澳门：1000233(3)
    let Macao = /^[1|5|7]{1}[0-9]{6}\([0-9]\)$/;
    const result = idCard1.test(value) || idCard2.test(value) || HongKong.test(value) || Taiwan.test(value) || Macao.test(value)
    console.log(result);
    return result;
  }
}

export default function(type, value) {
  return validator[type](value);
}